<template>
  <div class="mainr" style="background-color: #DEF2F2;">
    <!--<div style="top: 100px;position: fixed;left:0;z-index: 999;" v-if="textCopy"> 
        <div class="text" v-copy='textCopy' style="padding: 10px;background-color: #0c0c0c;color: #fff;">复制链接</div>
      </div>-->
    <div style="height:233px">
      <img style="width:100%" mode="aspectFit" src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/header-a.png"/>
    </div>
    <div class="cli-body" v-if="activityGoodsInfo">
		<div class="cli-body-goods">
			<div class="cli-body-goods-top" v-if="activityGoodsInfo">
				<div style="width:120px;float:left">
					<div style="color:#666666;font-size: 14px;">原订单金额 ¥{{activityGoodsInfo.orderAmount}}</div>
					<div style="color:#F24949;font-size: 16px;margin-top:10px">砍后价
						<span style="font-size: 15px;">￥{{activityGoodsInfo.orderAmount-activityGoodsInfo.haveBargainAmount}}</span> </div>
				</div>
				<div class="pic-list" style="">
					<img :src="item" v-for="(item, index) in activityGoodsInfo.goodsPics" v-bind:key="index" style="width:40px;height:40px;margin:3px;"/>
					<span v-if="activityGoodsInfo.goodsPics.length>3">...</span>
				</div>
			</div>
			<div class="cli-body-goods-boom" v-if="activityGoodsInfo">
				 好友还有机会获得：1次免费养护和LV真皮发卡~
			</div>
		</div>
		<div class="cli-body-bg">
			<div class="quest-one">
				<span class="time-panel">{{time[0]}}</span><span class="que-wenhou">:</span>
				<span class="time-panel">{{time[1]}}</span><span class="que-wenhou">:</span>
				<span class="time-panel">{{time[2]}}</span>
				<span style="margin:0 20px">后停止砍价</span>
			</div>
			<div class="jan-yikuai">已砍<span class="mory-bun">{{activityGoodsInfo.haveBargainAmount}}元</span></div>
			<div class="age-bugs" v-if="activityGoodsInfo.haveBargainAmount!=activityGoodsInfo.bargainAmount">
				<div :style="'width:'+activityGoodsInfo.haveBargainAmount/activityGoodsInfo.bargainAmount*223+'px'"></div>
			</div>
			<div class="age-bugs-df" v-if="activityGoodsInfo.haveBargainAmount==activityGoodsInfo.bargainAmount">
				<div ></div>
			</div>
			<button class="kan-botun-botun" v-if="activityGoodsInfo.status<30&&!activityGoodsInfo.haveBargainAmount" @click="shareShow=true">邀好友来砍价</button>
			<div v-if="activityGoodsInfo.status<30&&activityGoodsInfo.haveBargainAmount">
				<button class="kan-botun-botun-duan" @click="shareShow=true">邀好友砍价</button>
				<button class="kan-botun-botun-duan" @click="dfpay">支付使用</button>
			</div>
			
			<button class="kan-botun-botun-falg" v-if="activityGoodsInfo.status==40||(activityGoodsInfo.status==30&&!activityGoodsInfo.haveBargainAmount)">已结束</button>
			<button class="kan-botun-botun" v-if="activityGoodsInfo.status==30&&activityGoodsInfo.haveBargainAmount"  @click="dfpay">支付使用</button>
		</div>
		<div class="cli-content-tab">
			<div class="title">
				<div >
					<span class="chiose" @click="tabIndex=0"  v-if="tabIndex==0"> 砍价排行</span>
					<span class="no-chiose" @click="tabIndex=0"  v-if="tabIndex!=0"> 砍价排行</span>
				</div>
				<div>
					<span class="chiose" @click="tabIndex=1"  v-if="tabIndex==1">活动攻略</span>
					<span class="no-chiose" @click="tabIndex=1" v-if="tabIndex!=1">活动攻略</span>
				</div>
			</div>
			<div>

			</div>
			<div v-if="tabIndex==0" style="min-height: 200px;">
				<div style="text-align: center;height:400px;padding:50px" v-if="!relist||relist.length==0">
					<span style="color:#ccc">暂无好友砍价</span>
				</div>
				<div class="line-paople" v-for="(item,index) in relist" v-bind:key="index">
					<div>
						<img class="avader" :src="item.headImgUrl||'http://mi.baozheng.cc/img/default_avatar.92027116.png'"/>
					</div>
					<div style="width: 160px;margin-top: 3px;">
						<div>
							<div class="nice-name">{{item.customerName}}</div>
							<div class="zang-icon">答题狂砍一刀</div>
						</div>
						<div class="time">
							{{item.ftime}}
						</div>
					</div>
					<div class="kandiao">
						砍掉{{item.bargainAmount}}元
					</div>
				</div> 
			</div>
				<!-- <view class="more-botton">
					<view style="width:200px;width: 100px;margin-left: calc(50% - 100px);">
						<p style="text-align: center;color:#CCCCCC">
							加载更多
						</p>
						<image style="width:40px;height:20px" src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/header-a.png"></image>
					</view>
				</view> -->
			<!-- </view> -->
			<div style="padding:20px" class="pading-goods" v-if="tabIndex==1">
				<p>1.本次活动为邀请好友助力砍价活动。</p>
				<p>2.用户在确认诊断方案后，可以在付款前发起邀请好友助力砍价，限时1小时。</p>
				<p>3.邀请好友来砍价，本单最高可立减66元，砍价金额系统实时计算自动在总额中减去，多答多减。</p>
				<p>4.邀请好友答题，准确率越高，砍价金额越高。</p>
				<p>5.邀请的好友答对全部题目，即可获得奢侈品箱包免费清洗服务一次（可选连带上色下单，不包邮）；部分答对，可获得LV真皮精美小发卡一只（下单随包寄回）。 </p>
			</div>
		</div>
    <div style="width:100%;height:30px"></div>
	  </div>
    <van-popup v-model="shareShow" style="background-color: rgba(127, 255, 212, 0);">
      <div style="margin-bottom: 400px;">
         <img src="/images/home/share-dialog.png" alt="" style="width:100%">
      </div>
     
    </van-popup>
    <van-popup v-model="isGoOn"  style="padding: 20px;width: 300px;border-radius: 25px;">
      <div class="dig-contxt">还没砍到66元，是否继续挑战？</div>
      <span style="color:#7ADFDF;line-height: 60rpx;width: 150px;font-size:20px;background-color: #fff;padding: 0 50px;" @click="pay">不了</span>
      <!-- <van-button class="ask-get-button" @click="pay"    style="color:#7ADFDF;line-height: 60rpx;width: 150px;font-size:20px;background-color: #fff;">不了</van-button> -->
	    <van-button class="ask-get-button" @click="isGoOn = false"    style="line-height: 60rpx;width: 150px;font-size:20px">好，继续分享</van-button>
    </van-popup>
  </div>	
</template>

<script>
import publicObj from "@/assets/js/public";
import api from "./api";
import wxShare from "@/assets/js/wx.share";
import { Toast } from "vant";
import zhugeObj from "@/assets/js/track";
const TIME_COUNT = 60;
const convertObj=(data)=>{
  let _result = [];
  for (let key in data) {
    let value = data[key];
    if (value.constructor == Array) {
      value.forEach(function(_value) {
        _result.push(key + "=" + _value);
      });
    } else {
      _result.push(key + '=' + value);
    }
  }
  return _result.join('&');
}
export default {
  name: "sendIndex",
  data() {
    return {
      tabIndex:0,
      timeReal:0,
      time:['00','00','00'],
      copyTemp : '',
      isGoOn:false,
      textCopy:'',
      relist:[{
          headImgUrl:'https://baozheng-nice-new.baozheng.cc/uploads/bag/order/front/000/023/566/ad5bf62b.jpg?x-oss-process=image/resize,m_fill,h_300,w_300,color_FFFFFF,image/format,jpg,q_80',
          customerName:'jiersdfwe',
          ftime:'20-12-03',
          bargainAmount:'324'
      }],
      activityGoodsInfo: {
        orderAmount:23,
        haveBargainAmount:3,
        status:20,
        goodsPics: [
          "https://baozheng-nice-new.baozheng.cc/uploads/bag/order/front/000/023/566/ad5bf62b.jpg?x-oss-process=image/resize,m_fill,h_300,w_300,color_FFFFFF,image/format,jpg,q_80"
        ]
      },
      shareShow:false
    };
  },
  watch: {},
  computed: {
    token() {
      return this.$store.state.token;
    },
    customerId() {
      return localStorage.getItem("customerId");
    }
  },
  created() {
    const  obj = this.$route.query
    this.queryObject = obj
    this.copyTemp = location.origin + '/bargaining/rabbit-index?' + this.convertObj(obj)
    this.getActivityInfo()
  },
  mounted() {
    
  },
  methods: {
     dfk(){
       this.isGoOn = false
       this.shareShow=true
     },
     convertObj(data){
      let _result = [];
      for (let key in data) {
        let value = data[key];
        if (value.constructor == Array) {
          value.forEach(function(_value) {
            _result.push(key + "=" + _value);
          });
        } else {
          _result.push(key + '=' + value);
        }
      }
      return _result.join('&');
    },
    setCopy(){
      
    },
    changeTab(e){
      let {index} = e.currentTarget.dataset;
      this.setData({
        tabIndex:index
      })
    },
    async barrainList(){
      let  bargainActivityRecordId = this.activityGoodsInfo.id
      const res =  await api.getKanjiaList({bargainActivityRecordId})
      let arrayOfSquares=[]
      if(res){
        arrayOfSquares = res.map(function (item) {
          item.ftime = item.createTime.slice(5,16);
          return item
        });
      }
      this.relist = arrayOfSquares
      this.tabIndex = arrayOfSquares.length==0?1:0
    },
    dfpay(){
      if(this.activityGoodsInfo.status!=30){
        this.isGoOn = true
        return
      }else{
        this.pay()
      }
    },
    resh(){
      this.getActivityInfo()
    },
    async pay(){
      this.isGoOn = false
      let id = this.activityGoodsInfo.id
      try{
        const res =  await api.pay({id})
        Toast('已将砍价金额充值到账户余额，可作为支付抵扣使用！');
        setTimeout(()=>{
          this.resh()
        },100)
        
        
      }catch(e){
        this.resh()
      }
      
    },
    goTime(){
      this.timeReal=this.activityGoodsInfo.countDownExpired
      trbulTime = setInterval(()=>{
        this.toHHmmss()
      },1000)
    },
    toHHmmss() {
      this.timeReal= this.timeReal-1000
      let {timeReal} = this
      if(timeReal<=0){
        clearInterval(trbulTime)
      }
      let s;
      let hours = parseInt((timeReal % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = parseInt((timeReal % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = (timeReal % (1000 * 60)) / 1000;
      s = (hours < 10 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds);
      let ss = s.split(':')
      let df = Math.round(ss[2])
      ss[2] = df< 10 ? ('0' + df) : df
      this.time = ss
    },
    getActivityInfo(index){
      // let open = {
      //   bargainActivityId:1,
      //   orderAmount:1805,
      //   goodsIds:'393591,359349'
      // }
      api.getActivityInfo(this.queryObject).then((res)=>{
        res.haveBargainAmount =(+res.haveBargainAmount)
        res.goodsPics = res.goodsPics.map(function (item) {
          item= item.split('?')[0]+'?x-oss-process=image/resize,m_lfit,h_100,w_100,color_FFFFFF,image/format,jpg';
          return item
        });
        
        this.activityGoodsInfo = res
        this.textCopy = this.copyTemp+ '&activityGoodsInfoId='+res.id
        this.setShare()
        // this.setCopy()
        this.barrainList()
        res.countDownExpired&&this.goTime()
      }).catch((res)=>{
          
      })
    },
    setShare(){
      setTimeout(()=>{
        let shareBody = {
          desc : '姐妹们一起来砍价',
          title : '还能免费洗包！',
          link :this.textCopy,
          imgUrl:'/images/base/share-kanyidao.png'
        }; 
        
        wxShare(shareBody).then(()=>{
          
        });
      },400)
    }
  }
};
</script>

<style scoped lang="scss">
/* Bargaining/pages/lead/index.wxss */
.page__bd{
  background-color: #DEF2F2;
}
.cli-body{
  width: 100%;
}
.cli-body-goods{
  height: 212px;
  width: calc(100% - 48px);
  margin:0 24px;
  background: #FFFFFF;
  border-radius: 20px;
  position: relative;
  top: -44px;
}
.cli-body-bg{
  width: calc(100% - 48px);
  height: 520px;
  margin:0 24px;
  background: #FFFFFF;
  border-radius: 20px;
}
.cli-body-goods-top{
  height:120px;
  padding: 22px 19px;
  padding-bottom: 0;

}
.cli-body-goods-boom{
  height: 70px;
  line-height: 70px;
  background-color: #FFF8DF;
  color: #8B3620;
  font-size: 24px;
  padding-left: 20px;

}
.pic-list{
  width:350px;
  float:right;
}
.pic-list image{
  width:80px;
  height: 80px;
  margin-right: 20px;
}
.kan-botun-botun{
  font-size: 30px;
  margin-left: calc(50% - 301px)!important;
  width: 602px!important;
  height: 100px;
  line-height:60px;
  text-align: center;
  color: #fff;
  background: linear-gradient(317deg, #00A6A6 0%, #7ADFDF 100%);
  box-shadow: 0px 10px 10px 0px rgba(99, 191, 191, 0.5);
  border-radius: 50px;
}
.kan-botun-botun-duan{
  font-size: 30px;
  margin-left: calc(50% - 301px)!important;
  width: 280px!important;
  height: 100px;
  line-height:60px;
  text-align: center;
  color: #fff;
  float: left;
  background: linear-gradient(317deg, #00A6A6 0%, #7ADFDF 100%);
  box-shadow: 0px 10px 10px 0px rgba(99, 191, 191, 0.5);
  border-radius: 50px;
}
.kan-botun-botun-falg{
  font-size: 30px;
  margin-left: calc(50% - 301px)!important;
  width: 602px!important;
  height: 100px;
  line-height:70px;
  text-align: center;
  color: #fff;
  background: linear-gradient(317deg, #afafaf 0%, #d0d0d0 100%);
  box-shadow: 0px 10px 10px 0px #afafaf;
  border-radius: 50px;
}
.age-bugs{
  margin:50px 0;
  margin-left: calc(50% - 273px);
  width: 546px;
  height: 24px;
  background: #DEF2F2;
  border-radius: 12px;
}
.age-bugs-df{
  margin:50px 0;
  margin-left: calc(50% - 273px);
  width: 546px;
  height: 24px;
  background: #DEF2F2;
  border-radius: 12px;
}
.jan-yikuai{
  color:#333333;
  font-size:36px;
  text-align: center;
  margin-top: 30px;
}
.age-bugs div{
  // margin:50px;
  height: 24px;
  border-radius: 12px;
  border-bottom-left-radius: 12px;
  background: #7ADFDF;
}
.age-bugs-df div{
  // margin:50px;
  height: 24px;
  border-radius: 12px;
  background: #7ADFDF;
}
.quest-one{
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #8F3D27;
  line-height: 24px;
  text-align: center;
  padding: 50px 0;

}
.time-panel{
  width: 52px;
  height: 32px;
  background: #8F3D27;
  border-radius: 4px;
  color: #fff;
  padding: 5px 10px;
}
.que-wenhou{
  padding: 5px 10px;
}
.mory-bun{
  font-size: 64px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #F24949;
  line-height: 64px;

}
.cli-content-tab{
  width: calc(100% - 48px);
  margin:0 24px;
  background: #FFFFFF;
  border-radius: 20px;
  margin-top: 30px;
}
.cli-content-tab .title{
  width:100%;
  height:80px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: #EFEFEF;

}
.cli-content-tab .title div{
  width: 50%;
  text-align: center;
  float: left;
  line-height: 80px;
  height:80px;
}
.chiose{
  border-bottom-style: solid;
  border-bottom-width: 6px;
  border-color: #7ADFDF;
  padding: 12px 0;
  font-weight: 600;
}
.no-chiose{
  color: #666666;
  font-weight: 600;
}
.pading-goods{
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 40px;

}
.line-paople{
  height: 76px;
  width: calc(100% - 88px);
  padding: 20px 44px;

}
.line-paople div{
  float: left;
}

.avader{
  width: 76px;
  height: 76px;
  border-radius: 50%;
}
.time{
  height: 24px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 24px;
}
.zang-icon{
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #D5865B;
  line-height: 22px;
  padding: 5px 10px;
  border: 1px solid #D5865B;
}
.kandiao{
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #F24949;
  line-height: 28px;
  float: right!important;
  line-height: 50px;
}
.more-botton{
  margin-left: 44px;
  width: calc(100% - 88px);
  border-top-style: solid;
  border-top-width: 1px;
  border-color: #CCCCCC;
  margin-top: 30px;
  padding-top: 30px;
}
/*-------------------dialog----------------------*/
.dialog-askq .weui-dialog__hd{
  display: none;
}
.dialog-fill .weui-dialog__hd{
  display: none;
}
.dialog-fill .weui-dialog__ft{
  /* display: none; */
  padding-top: 20px;
}
.dialog-fill .weui-dialog__bd{
  margin: 0;
  padding: 0;
}
.no-button{
  font-size: 36px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500!important;
  color: #7ADFDF!important;
  height: 100px;
  line-height: 100px;
  margin: 0 20px;
}
.yes-button{
  width: 280px;
  height: 100px;
  line-height: 100px;
  font-weight: 500!important;
  color: #fff!important;
  background: linear-gradient(317deg, #00A6A6 0%, #7ADFDF 100%);
  border-radius: 49px;
  margin: 0 20px;
}
.weui-dialog__btn::after{
  border-left:0!important
}
.dig-contxt{
  width: 100%;
  text-align: center;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 50px;
  margin: 70px 0;
}
.kan-dist{
  width: 100%;
  text-align: center;
  height: 140px;
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 37px;
}
.kan-dist-df{
  width: 100%;
  text-align: center;
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 37px;
}
.kan-title{
  width: 100%;
  height: 37px;
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 37px;
  margin-top: 60px;
}
.ask-title{
  width: 100%;
  text-align: left;
  margin:50px 0;
  height: 48px;
  font-size: 34px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 48px;
}
.ask-anser{
  width: 100%;
  height: 74px;
  background: #7ADFDF;
  border-radius: 40px;
}
.ask-anser-2{
  width: calc(100% - 160px);
  height: 74px;
  text-align: left;
  padding: 0 80px;
  line-height: 74px;
  border-radius: 40px;
  border: 2px solid #979797;
  margin-bottom: 40px;
}
.dialog-yidap .weui-dialog__ft{
  display: none;
}
.get-num{
  font-size: 92px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #F24949;
  line-height: 92px;

}
.get-num-danwei{
  font-size: 44px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 44px;
}
.ask-get-button{
  width:100%;
  height: 100px;
  background: linear-gradient(317deg, #00A6A6 0%, #7ADFDF 100%);
  /* box-shadow: 0px 20px 20px 0px rgba(99, 191, 191, 0.5); */
  border-radius: 100px;
  line-height: 100px;
  color: #fff;
  margin:30px 0;
  font-size: 18px;
}
.ask-get-dis{
  width: 100%;
  height: 48px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 48px;
  margin: 20px 0;
}
.dialog-yidap .weui-dialog__bd{
  margin-bottom: 0!important;
}
.disaag .weui-dialog__bd{
  margin-bottom: 50px!important;
}
.title-code{
  width: 100%;
  height: 56px;
  font-size: 40px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 56px;

}
.dialog-code .weui-dialog__ft{
  display: none;
}
.dialog-code .weui-dialog__hd{
  display: none;
}
.dialog-code .weui-dialog__bd{
  margin: 100px 0;
}
.nice-name{
  // /* width: 155px; */
  // height: 60px;
  overflow: hidden;
  margin-right: 15px;
}
</style>
